module.exports = __webpack_public_path__ + "static/prepped-mobile-4-c9fbd40d3784552646d4f144a525fefb.jpg";